














































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import AmetrasResponsiveTabBar from '@/views/pageskeleton/AmetrasResponsiveTabBar.vue';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';
import {CompositeKeyType} from '@/interfaces/key.interface';
import {FormularInstance} from './formular/form.interface';
import {DYNAMIC_FIELD_RESOLVER_INSTANCE} from '@/fields/dynamic-field-resolver';

export interface ToolbarButtonClickedEventData {
  button: DisguiseDto.ToolbarButtonDto; // the clicked button configuration
  deleteFunctionRef?: () => void; // reference to FormularTemplate.doDelete()
}

/**
 * This is a component that can render dynamic contents
 */
@Component({
  name: 'ametras-dynamic-content',
  components: {
    LazyDataTableTemplate: () => import('./datatable/DataTableTemplate.vue'),
    LazyFormTemplate: () => import('./formular/FormTemplate.vue'),
    AmetrasResponsiveTabBar
  }
})
export default class AmetrasDynamicContent extends Vue {

  @Prop() dynamicContent!: DisguiseDto.DynamicContentUnion;
  @Prop({
    type: Object as () => CompositeKeyType,
    required: false,
    default: () => {
      return {};
    }
  }) editKey!: CompositeKeyType;
  // optional and used in formular only
  @Prop() overwrittenFields?: { [fieldName: string]: DisguiseDto.FTFieldDto };
  @Prop() contentTitle!: string;
  @Prop() object!: any;
  @Prop() closable!: boolean;
  @Prop() fullscreen!: boolean;
  @Prop() handleDialogCloseEventSeparately!: boolean;

  // if the view contains a formular, then this member holds the instance
  formularInstance: FormularInstance | null = null;
  // a value indicating that the tabs must be rerendered
  tabRenderKeyCount: number = 0;

  dynamicFieldResolver = DYNAMIC_FIELD_RESOLVER_INSTANCE;

  passthroughAllEventsVueOnMap: VueOnMapType =
      FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
        this.$emit(eventName, eventArgs);
      });


  onToolbarButtonClick(event: Event, button: DisguiseDto.ToolbarButtonDto) {
    const eventArgs: ToolbarButtonClickedEventData = {
      button
    };
    if (this.formularInstance) {
      eventArgs.deleteFunctionRef = this.formularInstance.doDelete;
    }
    this.$emit('toolbar-button-clicked', eventArgs);
  }

  closeDialog(event: Event) {
    if (this.closable) {
      event.stopPropagation();
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.handleDialogCloseEventSeparately) {
        this.$emit('closeDialog');
      } else {
        this.$emit('close');
      }
    }
  }

  afterFormularInitialized(formularInstance: FormularInstance) {
    this.formularInstance = formularInstance;
  }
}
